import { Building2, CalendarPlus, Handshake } from 'lucide-react';
import { Description, Heading } from '@heroui/react';

const STEPS = [
  {
    n: '01',
    Icon: Building2,
    title: 'O gestor cadastra o condomínio',
    body: 'Blocos, apartamentos, vagas e moradores. Cada pessoa entra com o próprio login.',
  },
  {
    n: '02',
    Icon: CalendarPlus,
    title: 'Quem tem vaga abre uma janela',
    body: 'Viagem, home office, fim de semana. Recorrente ou pontual, empréstimo ou aluguel.',
  },
  {
    n: '03',
    Icon: Handshake,
    title: 'O vizinho solicita e o dono aprova',
    body: 'O uso fica registrado. Se alguém ocupar indevido, o morador avisa o condomínio.',
  },
] as const;

export function LandingHowItWorks() {
  return (
    <section id="como-funciona" className="scroll-mt-24 border-t border-separator bg-surface">
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-4 py-16 sm:px-6 lg:py-20">
        <div className="max-w-2xl space-y-3">
          <Heading level={2} className="text-3xl font-bold tracking-tight">
            Três passos. Sem planilha.
          </Heading>
          <Description className="text-base">
            O fluxo que já existe no dia a dia do prédio, com rastro e sem atrito.
          </Description>
        </div>

        <ol className="grid gap-8 md:grid-cols-3">
          {STEPS.map(({ n, Icon, title, body }) => (
            <li key={n} className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <span className="font-mono text-sm font-semibold tabular-nums text-accent">{n}</span>
                <div className="flex size-10 items-center justify-center rounded-full bg-accent-soft text-accent">
                  <Icon size={20} />
                </div>
              </div>
              <Heading level={3} className="text-lg font-semibold">
                {title}
              </Heading>
              <Description>{body}</Description>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
